import PodcastMedia, { PodcastMediaProps } from './PodcastMedia';

export default PodcastMedia;
export type { PodcastMediaProps };
